import React from "react";
import { Button } from "@chakra-ui/react";
import { haptic } from "@/lib/haptic";

interface ReviewButtonProps {
  bgColor: string;
  onClick: () => void;
  text: string;
}

const ReviewButton: React.FC<ReviewButtonProps> = ({
  bgColor,
  onClick,
  text,
}) => {
  const handleClick = () => {
    haptic.soft();
    onClick();
  };

  return (
    <Button
      bg={bgColor}
      color="white"
      rounded="xl"
      onClick={handleClick}
      fontSize="base"
      height="var(--button-height)"
      _focus={{ bg: bgColor }}
      _hover={{ bg: bgColor }}
      className="w-full"
    >
      {text}
    </Button>
  );
};

export default ReviewButton;
